/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("createRoleModule", []).
controller("createRoleCtrl", ["$scope", "$element", "$validation", "modalDialog", "$modalInstance", "httpService", "roleId", "roleName", function($scope, $element, $validation, modalDialog, $modalInstance, httpService, roleId, roleName) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {

        };
        $scope.data = {
            roleId: roleId,
            roleName: roleName
        }
    }

    function initData() {
        requestData();
    }
    $scope.confirm = function() {
        $validation.validate($scope.createForm).success(function() {
            $modalInstance.close($scope.data);
        }).error(function() {
            angular.invalidPosition($scope.createForm, $element);
        });
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    function requestData() {}
    /**
     * [fullTextSearch description;]
     * @param  {[type]} ev [description:按下回车也能提交]
     */
    $scope.fullTextSearch = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            $modalInstance.close($scope.roleName);
        }
    };
}]);